import { createAri } from '@atlassian/jira-platform-ari';
import type { PublicToInternalPropertyTransformerContext } from '../../types';
import type {
	AllowedValuesOverrides,
	FieldOptionsFilter,
	OptionsVisibility,
} from '../../types/options-visibility';
import { validateSetOptionsVisibilityRule } from '../get-common-field-validators';

export const transformSelectSetOptionsVisibility = ({
	isVisible,
	options,
}: OptionsVisibility): AllowedValuesOverrides => ({
	operation: isVisible ? 'ALLOW' : 'EXCLUDE',
	ids: options,
});

export const transformOptionIdsToARI = (
	optionIds: string[],
	{ tenantContext, fieldContext }: PublicToInternalPropertyTransformerContext,
) =>
	optionIds.map((optionId) => {
		const resourceId = `${fieldContext.fieldId}/${optionId}`;
		return createAri({
			resourceOwner: 'jira',
			cloudId: tenantContext.cloudId,
			resourceType: 'issue-field-option',
			activationId: tenantContext.activationId,
			resourceId,
		});
	});

export const transformSetOptionsVisibilityAri = (
	{ isVisible, options }: OptionsVisibility,
	_lookupValues: undefined,
	context: PublicToInternalPropertyTransformerContext,
): FieldOptionsFilter => ({
	operation: isVisible ? 'ALLOW' : 'EXCLUDE',
	optionIds: transformOptionIdsToARI(options, context),
});

// transformer is called on FieldPublicShape type
export const transformSelectGetOptionsVisibility = ({
	isVisible,
	options,
}: OptionsVisibility): OptionsVisibility => ({
	isVisible,
	options,
});

export const optionsVisibilityContainNoMoreThan100Items = (optionsVisibility: OptionsVisibility) =>
	optionsVisibility.options.length <= 100;

export const validateSetOptionsVisibility = (optionsVisibility: OptionsVisibility): boolean =>
	validateSetOptionsVisibilityRule(optionsVisibility) &&
	optionsVisibilityContainNoMoreThan100Items(optionsVisibility);
